import { cloneDeep } from "lodash";
import React, { useState } from "react";
import MMPopup from "../../../../mmcomponents/mmpopup/MMPopup";
import MMTabs from "../../../../mmcomponents/mmtabs/MMTabs";
import { Icon } from "../../../../_foundation/_buttons";
import ElementDesign from "../../elements/popups/ElementDesign";
import ElementSettings from "../../elements/popups/ElementSettings";

const tabs = {
  design: {
    name: "Design",
    icon: "paint-brush",
  },
  settings: {
    name: "Einstellungen",
    icon: "cog",
  },
};

function RowPopup(props) {
  const [row, setRow] = useState(cloneDeep(props.row));
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [selectedTab, setSelectedTab] = useState("design");

  const onEdit = (property, value) => {
    const updatedRow = cloneDeep(row);

    if (property.substring(0, 8) === "options.") {
      let { options } = updatedRow;
      if (!options) options = {};
      options[property.replace("options.", "")] = value;
      updatedRow.options = options;
    } else {
      updatedRow[property] = value;
    }

    setRow(updatedRow);
    setUnsavedChanges(true);
  };

  const onUpdate = () => {
    if (props.actions.onUpdateRow) props.actions.onUpdateRow(row);
  };

  const actions = {
    onEdit,
    onUpdate,
  };

  const onCancel = () => {
    if (
      !unsavedChanges ||
      (unsavedChanges &&
        window.confirm(
          "Möchtest Du wirklich abbrechen? Änderungen gehen unwiderruflich verloren."
        ) &&
        props.onCancel)
    )
      props.onCancel();
  };

  return (
    <div className="pagebuilder-row-popup">
      <MMPopup size="medium" show={true} handleClose={onCancel}>
        <h3>Zeile bearbeiten</h3>
        <div className="admin-tabs">
          <MMTabs
            tabs={tabs}
            selected={selectedTab}
            onUpdate={(selectedKeyName) => setSelectedTab(selectedKeyName)}
          />
        </div>
        {selectedTab === "design" && (
          <ElementDesign item={row} itemType="row" actions={actions} />
        )}
        {selectedTab === "settings" && (
          <ElementSettings item={row} itemType="row" actions={actions} />
        )}
        <div className="text-right">
          <button className="small primary hollow button" onClick={onCancel}>
            <Icon icon="times" left /> Abbrechen
          </button>
          <button className="small primary button" onClick={onUpdate}>
            <Icon icon="check" left /> Übernehmen
          </button>
        </div>
      </MMPopup>
    </div>
  );
}

export default RowPopup;
